import { select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BaseAsyncValue } from '../../../../shared/models/async-value';
import { getIsContractProductLoading } from '../selectors/products.selectors';

export namespace ContractProductsDisabler {
  export class IsLoading extends BaseAsyncValue<Boolean> {
    getValue(): Observable<Boolean> {
      return this.store.pipe(select(getIsContractProductLoading), takeUntil(this.ngDestroy));
    }
  }
}
